import { type ClubBenefit, type ClubBenefitType } from 'shopify-types'

import type { ClubBenefitFieldsFragment } from '../__generated/storefront'

export type GQLClubBenefitNode = ClubBenefitFieldsFragment

export const mapGQLClubBenefit = (node: GQLClubBenefitNode): ClubBenefit => {
  const benefit: {
    handle: string
    title: string
    type: ClubBenefitType
    discountCode: string | null
    image: { url: string; altText: string | null } | null
    pageSlug: string | null
  } = {
    handle: node.handle,
    title: '',
    type: 'discount',
    discountCode: null,
    image: null,
    pageSlug: null,
  }

  node.fields.forEach(field => {
    switch (field.key) {
      case 'title':
        benefit.title = field.value ?? ''
        break
      case 'type':
        benefit.type = (field.value as ClubBenefitType | null) ?? 'discount'
        break
      case 'discountcode':
        benefit.discountCode = field.value || null
        break
      case 'image': {
        const ref = field.reference
        if (ref && 'image' in ref && ref.image) {
          benefit.image = { url: ref.image.url, altText: ref.image.altText ?? null }
        }
        break
      }
      case 'pageslug':
        benefit.pageSlug = field.value || null
        break
    }
  })

  return benefit
}
